import { Link } from 'react-router-dom'

import { Button, Grid3x3Icon } from '@buffer-mono/popcorn'
import type { ButtonProps } from '@buffer-mono/popcorn'
import { BufferTrackerReact } from '@buffer-mono/tracking-plan'

import { useSelectedChannel } from '../ChannelContext'

import type { JSX } from 'react'

type GridPreviewButtonProps = Omit<ButtonProps, 'children'>

export function GridPreviewButton(
  props: GridPreviewButtonProps,
): JSX.Element | null {
  const channel = useSelectedChannel()

  if (channel.service === 'instagram' && channel.type !== 'profile') {
    return (
      <Button
        id="grid-preview"
        variant="secondary"
        size="large"
        as={Link}
        to={`/channels/${channel.id}/shop-grid`}
        onClick={(): void => {
          BufferTrackerReact.instagramGridPreviewIconClicked({
            product: 'publish',
            clientName: 'publishWeb',
            channelId: channel.id,
          })
        }}
        {...props}
      >
        <Grid3x3Icon />
        Grid
      </Button>
    )
  }

  return null
}
